(() => {
  'use strict';
  if (window.__vpInternationalCheckoutNotice) return;
  window.__vpInternationalCheckoutNotice = true;

  const source = document.currentScript;
  const root = (source && source.dataset.vpRoot) || (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const base = new URL(root.endsWith('/') ? root : root + '/', window.location.origin);
  const updateUrl = new URL('cart/update.js', base).href;
  const checkoutUrl = new URL('checkout', base).href;
  const attribute = 'International shipping notice acknowledged';
  let dialog;
  let pending;
  let resuming = false;
  let busy = false;
  let previousFocus;

  function checkoutLink(value) {
    if (!value) return false;
    try {
      const url = new URL(value, window.location.href);
      return url.origin === window.location.origin && /(?:^|\/)checkouts?(?:\/|$)/.test(url.pathname);
    } catch (_) {
      return false;
    }
  }

  function checkoutControl(element) {
    if (!(element instanceof Element)) return false;
    if (element.matches('[name="checkout"], [data-checkout-button]')) return true;
    if (element.matches('a[href]') && checkoutLink(element.getAttribute('href'))) return true;
    if (element.hasAttribute('formaction') && checkoutLink(element.getAttribute('formaction'))) return true;
    if (!element.matches('button, input[type="submit"], [role="button"]')) return false;
    const label = (element.getAttribute('aria-label') || element.value || element.textContent || '').replace(/\s+/g, ' ').trim();
    return /^(?:(?:proceed|continue) to |secure )?check\s*out$/i.test(label);
  }

  function ensureDialog() {
    if (dialog) return;
    const style = document.createElement('style');
    style.textContent = '#VPInternationalNotice{box-sizing:border-box;width:min(440px,calc(100vw - 32px));max-width:440px;max-height:calc(100dvh - 32px);margin:auto;padding:28px;border:1px solid #d6d6d1;border-radius:4px;background:#fff;color:#151815;font:16px/1.5 Arial,sans-serif;overflow:auto;overscroll-behavior:contain;text-align:left;box-shadow:0 16px 64px #0005}#VPInternationalNotice:not([open]){display:none}#VPInternationalNotice::backdrop{background:rgb(0 0 0 / 62%)}#VPInternationalNotice *{box-sizing:border-box}#VPInternationalNotice .vp-intl-brand{margin:0 0 12px;font-size:12px;font-weight:700;letter-spacing:2px}#VPInternationalNotice h2{margin:0 0 12px;font:700 24px/1.15 Arial,sans-serif;letter-spacing:-.4px;color:inherit}#VPInternationalNotice p{margin:0 0 16px;color:inherit;font-size:15px;line-height:1.5}#VPInternationalNotice .vp-intl-title{margin:20px 0 6px;font-size:12px;font-weight:700;letter-spacing:1px}#VPInternationalNotice button{display:block;width:100%;min-height:48px;margin:12px 0 0;padding:14px 12px;border:1px solid #151815;border-radius:0;font:700 12px/1.35 Arial,sans-serif;letter-spacing:.7px;cursor:pointer;white-space:normal;text-transform:none;box-shadow:none}#VPInternationalNotice .vp-intl-continue{background:#151815;color:#fff}#VPInternationalNotice .vp-intl-back{background:#fff;color:#151815}#VPInternationalNotice button:disabled{opacity:.55;cursor:wait}#VPInternationalNotice button:focus-visible{outline:3px solid #697b43;outline-offset:3px}#VPInternationalNotice [role="alert"]{margin:12px 0 0;color:#a41b12;font-size:14px}#VPInternationalNotice [hidden]{display:none!important}@media(max-width:480px){#VPInternationalNotice{padding:24px}}';
    document.head.appendChild(style);
    dialog = document.createElement('dialog');
    dialog.id = 'VPInternationalNotice';
    dialog.setAttribute('aria-labelledby', 'VPInternationalNoticeTitle');
    dialog.setAttribute('aria-describedby', 'VPInternationalNoticeIntro');
    dialog.setAttribute('lang', 'en');
    dialog.setAttribute('dir', 'ltr');
    dialog.innerHTML = '<p class="vp-intl-brand">VALIANT PURSUIT®</p><h2 id="VPInternationalNoticeTitle">INTERNATIONAL ORDERS ONLY</h2><p id="VPInternationalNoticeIntro">Shipping outside the United States? Please review the following before checkout.</p><p class="vp-intl-title">DUTIES, TAXES &amp; IMPORT FEES</p><p>Your destination country may charge duties, taxes, customs, carrier or import fees upon delivery. <strong>These charges are NOT included in your order total and are the responsibility of the customer.</strong></p><p>Customs processing and local-carrier delays may affect delivery.</p><p role="alert" data-vp-intl-error hidden></p><button type="button" class="vp-intl-continue" data-vp-intl-continue>I UNDERSTAND — CONTINUE TO CHECKOUT</button><button type="button" class="vp-intl-back" data-vp-intl-back>GO BACK</button>';
    document.body.appendChild(dialog);
    dialog.querySelector('[data-vp-intl-back]').addEventListener('click', () => {
      if (busy) return;
      pending = null;
      dialog.close();
    });
    dialog.addEventListener('cancel', event => {
      if (busy) event.preventDefault();
      else pending = null;
    });
    dialog.addEventListener('close', () => {
      if (!resuming) pending = null;
      if (previousFocus && previousFocus.isConnected) previousFocus.focus({ preventScroll: true });
    });
    dialog.querySelector('[data-vp-intl-continue]').addEventListener('click', acknowledge);
  }

  function openNotice(action) {
    ensureDialog();
    if (busy || dialog.open) return;
    pending = action;
    previousFocus = document.activeElement;
    dialog.querySelector('[data-vp-intl-error]').hidden = true;
    dialog.showModal();
  }

  function interceptClick(event) {
    if (resuming || event.button > 0) return;
    const path = event.composedPath();
    if (dialog && path.includes(dialog)) return;
    const control = path.find(checkoutControl);
    if (!control || control.disabled || control.getAttribute('aria-disabled') === 'true') return;
    if (control.form && !control.form.noValidate && !control.formNoValidate && !control.form.checkValidity()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openNotice({ kind: 'click', control });
  }

  function interceptSubmit(event) {
    if (resuming || !(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if (!checkoutControl(event.submitter) && !checkoutLink(form.action)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openNotice({ kind: 'submit', form, submitter: event.submitter });
  }

  function resume(action) {
    resuming = true;
    try {
      if (action.kind === 'click' && action.control.isConnected && !action.control.disabled) {
        action.control.click();
      } else if (action.kind === 'submit' && action.form.isConnected) {
        if (action.submitter && action.submitter.isConnected && !action.submitter.disabled) action.form.requestSubmit(action.submitter);
        else action.form.requestSubmit();
      } else {
        window.location.assign(checkoutUrl);
      }
    } finally {
      resuming = false;
    }
  }

  async function acknowledge() {
    if (busy || !pending) return;
    busy = true;
    const action = pending;
    const confirm = dialog.querySelector('[data-vp-intl-continue]');
    const back = dialog.querySelector('[data-vp-intl-back]');
    const error = dialog.querySelector('[data-vp-intl-error]');
    const label = confirm.textContent;
    const controller = new AbortController();
    const timeout = window.setTimeout(() => controller.abort(), 10000);
    confirm.disabled = true;
    back.disabled = true;
    confirm.textContent = 'CONTINUING…';
    error.hidden = true;
    dialog.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(updateUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: { [attribute]: 'Yes' } }),
        signal: controller.signal
      });
      if (!response.ok) throw new Error('Unable to record acknowledgment');
      const cart = await response.json();
      if (!cart.attributes || cart.attributes[attribute] !== 'Yes') throw new Error('Acknowledgment was not saved');
      pending = null;
      dialog.close();
      resume(action);
    } catch (_) {
      pending = action;
      error.textContent = 'We could not continue to checkout. Please try again.';
      error.hidden = false;
    } finally {
      window.clearTimeout(timeout);
      busy = false;
      confirm.disabled = false;
      back.disabled = false;
      confirm.textContent = label;
      dialog.removeAttribute('aria-busy');
    }
  }

  window.addEventListener('click', interceptClick, true);
  window.addEventListener('submit', interceptSubmit, true);
  window.addEventListener('pageshow', () => {
    resuming = false;
    if (!busy) pending = null;
  });
})();